import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

import { HomePage } from "../feature/Pages/HomePage";
import { VisionContent } from "../feature/components/Vision/VisionContent";
import { CareersContent } from "feature/components/Careers/CareersContent";
import { FeaturesLandingPage } from "feature/components/Product/FeaturesLandingPage";
import { ProductContentHosts } from "feature/components/Product/Hosts/ProductContentHosts";
import { ProductContentGuests } from "feature/components/Product/Guests/ProductContentGuests";
import { ProductContentContractors } from "feature/components/Product/Contractors/ProductContentContractors";
import { TeamContent } from "feature/components/Team/TeamContent";

const LandingLayout = React.lazy(() => import("Layout/LandingLayout"));

const useStyles = makeStyles(() =>
  createStyles({
    loading: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "70vh",
    },
  }),
);

export default function CustomRouter() {
  const classes = useStyles();

  return (
    <Suspense
      fallback={
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      }
    >
      <LandingLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/about" element={<VisionContent />} />
          <Route path="/team" element={<TeamContent />} />
          <Route path="/careers" element={<CareersContent />} />
          <Route path="/product/features" element={<FeaturesLandingPage />} />
          <Route path="/product/hosts" element={<ProductContentHosts />} />
          <Route path="/product/guests" element={<ProductContentGuests />} />
          <Route
            path="/product/contractors"
            element={<ProductContentContractors />}
          />
        </Routes>
      </LandingLayout>
    </Suspense>
  );
}
